import * as React from 'react';


export default class ManageProfile extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <path opacity="0.01" d="M8.14353 7.75565C8.14353 7.75565 12.9795 9.05278 12.7545 14.832" stroke="#17B9F0"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M13.3468 14.6312H2.43773V12.5575C2.43773 9.90662 4.88022 7.75662 7.89279 7.75662C10.9054 7.75662 13.3468 9.90662 13.3468 12.5575V14.6312Z" stroke="#727272"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M10.08 4.18727C10.08 5.39545 9.10091 6.37455 7.89273 6.37455C6.68455 6.37455 5.70546 5.39545 5.70546 4.18727C5.70546 2.97909 6.68455 2 7.89273 2C9.10091 2 10.08 2.97909 10.08 4.18727Z" stroke="#727272"/>
      </svg>
    )
  }
}
